import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiUri, API_URI } from "src/app/API_URI";
import { User } from "src/app/_models/user";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private apiUri: ApiUri;
  private userSubject: BehaviorSubject<User>;
  public user: Observable<User>;

  constructor(
    public http: HttpClient,
    private router: Router,
    @Inject(API_URI) apiUri: ApiUri
  ) {
    this.apiUri = apiUri;
    this.userSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem("currentUser"))
    );
    this.user = this.userSubject.asObservable();
  }

  public getToken(): string {
    return this.userSubject.value.authToken;
  }

  public setToken(user) {
    this.userSubject.next(user);
    localStorage.setItem("currentUser", JSON.stringify(user));
    // this.startRefreshTokenTimer();
    const jwtToken = JSON.parse(atob(this.userValue.authToken.split(".")[1]));
  }

  public isLoggedIn(): boolean {
    if (this.userSubject.value.authToken) {
      return true;
    } else {
      return false;
    }
  }
  // public isAuthenticated(): boolean {
  //   // get the token
  //   const token = this.getToken();
  //   // return a boolean reflecting
  //   // whether or not the token is expired
  //   return tokenNotExpired(null, token);
  // }
  // }

  // private currentUserSubject: BehaviorSubject<any>;
  // public currentUser: Observable<any>;

  // constructor(private http: HttpClient, @Inject(API_URI) apiUri: ApiUri) {
  //   this.apiUri = apiUri;
  //     // this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser')));
  //     // this.currentUser = this.currentUserSubject.asObservable();
  // }

  //   public currentUserValue(): any {
  //       return this.currentUserSubject.value;
  //   }

  //   login(username: string, password: string) {
  //     let data ={
  //       "UserName": username,
  //       "Password": password
  //     }
  //       return this.http.post<any>(`${environment.apiUrl + this.apiUri.login.LOGIN}`,data)
  //           .pipe(map(user => {
  //             console.log(user);
  //               // store user details and basic auth credentials in local storage to keep user logged in between page refreshes
  //               user.authdata = window.btoa(username + ':' + password);
  //               localStorage.setItem('currentUser', JSON.stringify(user));
  //               this.currentUserSubject.next(user);
  //               return user;
  //           }));
  //   }

  //   logout() {
  //       // remove user from local storage to log user out
  //       localStorage.removeItem('currentUser');
  //       this.currentUserSubject.next(null);
  //   }

  forgotPassword(data: any): Observable<any> {
    return this.http.post(
      `${environment.apiUrl + this.apiUri.login.FORGET_PASSWORD}`,
      data
    );
  }

  resetPassword(data: any): Observable<any> {
    return this.http.post(
      `${environment.apiUrl + this.apiUri.login.RESET_PASSWORD}`,
      data
    );
  }

  changePassword(data: any): Observable<any> {
    return this.http.post(
      `${environment.apiUrl + this.apiUri.login.CHANGE_PASSWORD}`,
      data
    );
  }

  public get userValue(): User {
    return this.userSubject.value;
  }

  login(username: string, password: string) {
    return this.http
      .post<any>(`${environment.apiUrl + this.apiUri.login.LOGIN}`, {
        username,
        password,
      })
      .pipe(
        map((user) => {
          this.setToken(user);
          return user;
        })
      );
  }

  logout() {
    // this.http.post<any>(`${environment.apiUrl}/users/revoke-token`, {}, { withCredentials: true }).subscribe();
    // this.stopRefreshTokenTimer();
    // localStorage.removeItem("currentUser");
    // localStorage.removeItem("appLanguage");
    localStorage.clear();
    this.userSubject.next(null);
    this.router.navigate(["/Auth/Login"]);
  }

  logoutWithReload() {
    // localStorage.removeItem("currentUser");
    // localStorage.removeItem("appLanguage");
    localStorage.clear();
    this.userSubject.next(null);
    window.location.reload();
    this.router.navigate(["/Auth/Login"]);
  }

  refreshToken() {
    return this.http
      .post<any>(`${environment.apiUrl}/users/refresh-token`, {})
      .pipe(
        map((user) => {
          this.userSubject.next(user);
          // this.startRefreshTokenTimer();
          return user;
        })
      );
  }

  // helper methods

  private refreshTokenTimeout;

  private startRefreshTokenTimer() {
    // parse json object from base64 encoded jwt token
    const jwtToken = JSON.parse(atob(this.userValue.authToken.split(".")[1]));

    // set a timeout to refresh the token a minute before it expires
    const expires = new Date(jwtToken.exp * 1000);
    const timeout = expires.getTime() - Date.now() - 60 * 1000;
    this.refreshTokenTimeout = setTimeout(
      () => this.refreshToken().subscribe(),
      timeout
    );
  }

  private stopRefreshTokenTimer() {
    clearTimeout(this.refreshTokenTimeout);
  }
}
